import React from 'react';
import { Circle, CircleProps } from 'src/kit';

export type ImageWithFallbackProps = CircleProps & {
  className?: string;
  src?: string;
  fallbackSrc?: string;
  children?: any;
  shape?: 'circle' | 'square';
};

export const ImageWithFallback = ({
  src,
  alt,
  fallbackSrc,
  children,
  shape = 'circle',
  ...styledProps
}: ImageWithFallbackProps) => {
  const [state, setState] = React.useState<'loading' | 'success' | 'error'>('loading');

  const displayImage = React.useRef(window.document.createElement('img')).current;

  React.useEffect(() => {
    if (src) {
      displayImage.src = src;
      displayImage.onerror = () => {
        setState('error');
      };
      displayImage.onload = () => {
        setState('success');
      };
    }
    return () => {
      displayImage.onerror = function() {};
      displayImage.onload = function() {};
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  if (!src || state === 'error') {
    if (fallbackSrc) return <Circle as="img" src={fallbackSrc} alt={alt} objectFit="cover" {...styledProps} />;
    if (children) {
      return <Circle {...styledProps}>{children}</Circle>;
    }
  }
  return <Circle as="img" src={src} alt={alt} objectFit="cover" {...styledProps} />;
};
